import { ConfigBuildService } from './../../../features/dfte-grid-view/services/config-build.service';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DataService } from 'src/app/features/dfte-grid-view/config/data.service';
import { LegacyExtractService } from 'src/app/features/dfte-grid-view/services/legacy-extract-services.service';
import { MessageService } from 'src/app/features/dfte-grid-view/services/message.service';
 
interface FilterOption {
  label: string;
  value: any;
  key: string;
}
 
@Component({
  selector: 'app-config-build-home',
  templateUrl: './config-build-home.component.html',
  styleUrls: ['./config-build-home.component.scss'],
})
export class ConfigBuildHomeComponent implements OnInit {
  project_id: string = '';
  modulesCount: number | null = null;
  configBuildData: any[] = [];
  selectedModulePayload: any;
  selectedModuleName = '';
  selectedModuleId = '';
  selectedModuleNumber = 1;
  selectedModuleConfigTasks: any[] = [];
  originalSelectedModuleConfigTasks: any[] = [];
  selectedFilterOptions: FilterOption[] = [];
  searchKey = '';
  globalSearchFocused: boolean = false;
  filterPanelVisible: boolean = false;
  uploadedFilesData: any = {};
  selectedFile: File | null = null;
  modalOpen: boolean = false;
  is_complete: boolean = false;
  moduleCompletionStatus: number = 0;
  responseNull: string = '';
  taskData: string = '';
 
  multiSelectFilterOptions: FilterOption[] = [
    { label: 'Incomplete Tasks', value: 0, key: 'is_task_complete' },
    { label: 'Completed Tasks', value: 1, key: 'is_task_complete' },
  ];
 
  constructor(
    public _data: DataService,
    public celService: LegacyExtractService,
    private configBuildService: ConfigBuildService,
    private fb: FormBuilder,
    private https: HttpClient,
    private messageService: MessageService
  ) {}
 
  ngOnInit(): void {
    this.getDefaultResponse();
  }
  maskPage() {
    this._data.apiCallInProgress = true;
    document.getElementById('overlay').style.display = 'block';
  }
  unMaskPage() {
    this._data.apiCallInProgress = false;
    document.getElementById('overlay').style.display = 'none';
  }
  onClickSearch(){
 
 
   const searchInput = document.getElementById('searchInput') as HTMLInputElement;
   if (searchInput) {
       searchInput.focus();
       this.globalSearchFocused = true;
   }
  }
  getDefaultResponse() {
    const savedProjectId = sessionStorage.getItem('projectId');
    this.project_id = savedProjectId ? savedProjectId : 'defaultProjectId';
 
    this.maskPage();
 
    this.configBuildService
      .getConfigBuildModulesData(this.project_id)
      .subscribe(
        (response: any) => {
          this.unMaskPage();
          if (response.modules.length > 0) {
            this.modulesCount = response.modules.length;
            this.configBuildData = response.modules;
            this.selectedModuleName = response.modules[0].module_name;
            this.selectedModuleId = response.modules[0].module_id;
            this.getConfigBuildModulesTask(this.selectedModuleId);
            this.responseNull = null;
          }
        },
        (error: any) => {
          this.unMaskPage();
          const errorMessage =
            error.error?.message ||
            'An unexpected error occurred. Please try again later.';
          this.responseNull = errorMessage;
          this.messageService.showMessage(errorMessage, 'error');
        }
      );
  }
 
  getConfigBuildModulesTask(selectedModuleId: string) {
    this.configBuildService
      .getConfigBuildModulesToTaskData(selectedModuleId)
      .subscribe(
        (response: any) => {
          if (response.tasks.length > 0) {
            this.selectedModuleConfigTasks = response.tasks;
            this.originalSelectedModuleConfigTasks = response.tasks;
 
            const allTasksComplete = response.tasks.every(
              (task) => task.is_task_complete === 1
            );
 
            const module = this.configBuildData.find(
              (mod) => mod.module_id === selectedModuleId
            );
 
            module.is_module_complete = allTasksComplete ? 1 : 0;
 
            this.taskData = null;
          }
          this.unMaskPage();
        },
        (error: any) => {
          this.unMaskPage();
 
          const errorMessage =
            error.error?.message ||
            'An unexpected error occurred. Please try again later.';
          this.taskData = errorMessage;
        }
      );
  }
 
  handleModuleSelection(selectedModulePayload: any, moduleNumber: number) {
    this.selectedModulePayload = selectedModulePayload;
    this.selectedModuleName = selectedModulePayload.module_name;
    this.selectedModuleId = selectedModulePayload.module_id;
    this.selectedModuleNumber = moduleNumber;
    this.selectedModuleConfigTasks = [];
    this.originalSelectedModuleConfigTasks = [];
    this.maskPage();
    this.getConfigBuildModulesTask(this.selectedModuleId);
    this.selectedFilterOptions = this.multiSelectFilterOptions;
  }
 
  toggleFilterPanel() {
    this.filterPanelVisible = !this.filterPanelVisible;
  }
 
  handleResetAll() {
    this.selectedFilterOptions = this.multiSelectFilterOptions;
    this.handleFilterApply();
  }
 
  handleOptionCheckboxSelection(option: FilterOption) {
    const isSelected = this.selectedFilterOptions.some(
      (selected) => selected === option
    );
    if (isSelected) {
      this.selectedFilterOptions = this.selectedFilterOptions.filter(
        (selected) => selected !== option
      );
    } else {
      this.selectedFilterOptions.push(option);
    }
  }
 
  checkedStatus(option: any) {
    return this.selectedFilterOptions.some((selected) => selected === option);
  }
 
  handleFilterApply() {
    this.selectedModuleConfigTasks = [
      ...this.filterDataset(
        this.originalSelectedModuleConfigTasks,
        this.selectedFilterOptions
      ),
    ];
  }
 
  filterDataset(dataset: any[], selectedOptions: FilterOption[]): any[] {
    return dataset.filter((item) => {
      return selectedOptions.some((option) => {
        if (option.key) {
          return item[option.key] === option.value;
        } else {
          return item['is_task_complete'] === option.value;
        }
      });
    });
  }
 
  handleFocus() {
    this.globalSearchFocused = true;
  }
 
  handleBlur() {
    if (this.searchKey.length > 0) {
      this.globalSearchFocused = true;
    } else {
      this.globalSearchFocused = false;
    }
  }
 
  handleTaskSearch() {
    const tasksToFilter = this.originalSelectedModuleConfigTasks;
    const searchKeyLower = this.searchKey.toLowerCase();
 
    this.selectedModuleConfigTasks = tasksToFilter.filter((config: any) =>
      config['task_name'].toLowerCase().includes(searchKeyLower)
    );
  }
 
  handleTaskComplete(task: any, newTaskStatus: number) {
    this.maskPage();
 
    this.configBuildService
      .completeTask(task.task_id, this.selectedModuleId, newTaskStatus)
      .subscribe(
        (response: any) => {
          this.getConfigBuildModulesTask(this.selectedModuleId);
 
          this.messageService.showMessage(response.message, 'success');
        },
        (error: any) => {
          this.unMaskPage();
          this.messageService.showMessage(error.message, 'error');
        }
      );
  }
 
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const fileType = file.type;
      const validFileType =
        fileType ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      if (!validFileType) {
        alert('Invalid file type. Please select an XLSX file.');
        this.selectedFile = null;
        return;
      }
      this.selectedFile = file;
    }
  }
 
  uploadFile(): void {
    if (!this.selectedFile) {
      return;
    }
 
    const currentTime = new Date().toISOString();
    this.maskPage();
 
    this.celService
      .uploadXlsxFile(this.selectedFile, currentTime, this.project_id)
      .subscribe({
        next: (response: any) => {
          this.unMaskPage();
          this.closeModal();
 
          if (response.statusCode === 200) {
            this.messageService.showMessage(response.message, 'success');
            this.getDefaultResponse();
          } else {
            this.clearState(
              response.message || 'No modules found in the uploaded file.'
            );
            this.messageService.showMessage(response.message, 'error');
          }
        },
        error: (error: any) => {
          this.unMaskPage();
          const errorMessage =
            error.error?.message ||
            'An unexpected error occurred. Please try again later.';
          this.messageService.showMessage(errorMessage, 'error');
          this.clearState(errorMessage);
        },
      });
  }
 
  clearState(message: string) {
    this.modulesCount = 0;
    this.configBuildData = [];
    this.selectedModuleName = '';
    this.selectedModuleId = '';
 
    this.selectedModuleConfigTasks = [];
    this.originalSelectedModuleConfigTasks = [];
    this.responseNull = message;
  }
 
  downloadExcel(): void {
    this.maskPage();
 
    this.configBuildService.downloadExcelFile(this.project_id).subscribe(
      (response: Blob) => {
        this.unMaskPage();
        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none'; // Hide the anchor element
        a.href = url;
        a.download = `${this.project_id}+_configDetails.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.messageService.showMessage(
          'File Downloaded Successfully',
          'success'
        );
      },
      (error) => {
        this.messageService.showMessage(error.message, 'error');
      }
    );
  }
 
 
  openModal(): void {
    this.modalOpen = true;
  }
 
  closeModal(): void {
    this.modalOpen = false;
    this.selectedFile = null;
  }
}